import { render } from "./warehouse_product_admin.vue?vue&type=template&id=4e51fa8c&scoped=true"
import script from "./warehouse_product_admin.vue?vue&type=script&lang=js"
export * from "./warehouse_product_admin.vue?vue&type=script&lang=js"

import "./warehouse_product_admin.vue?vue&type=style&index=0&id=4e51fa8c&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e51fa8c"]])

export default __exports__